/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Une occurrence trouvée par la recherche de masse.
 */
export interface ImportLineSearchMatchDto {
    rowIndex?: number;
    columnIndex?: number;
    currentValue?: string;
    /** Valeur de remplacement proposée, éditable avant application. */
    newValue?: string;
    /** Colonne où écrire : celle du match, sauf colonne cible distincte. */
    targetColumnIndex?: number;
    /** Valeur actuelle de la colonne cible, quand elle diffère de la colonne du match. */
    targetCurrentValue?: string;
    /** true : la valeur cible est écrasée par newValue ; false : le terme trouvé est remplacé dans la valeur existante. */
    directSet?: boolean;
}
